import type { BufferForChangeId } from '../../../types';

export const changesReadyToApply = (bufferForChangeId: BufferForChangeId) => {
	const appsReady = Object.values(bufferForChangeId).filter(
		(fieldsChanges) => fieldsChanges !== null,
	);

	return appsReady.length === Object.keys(bufferForChangeId).length;
};
